import { Tag } from '@features/tags/types';

export enum DefectStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
}

export enum DefectSeverityEnum {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    CRITICAL = 'CRITICAL',
}

export enum DefectTypeEnum {
    AUTOTEST = 'autotest',
    PRODUCT = 'product',
}

export type Defect = {
    pk: number;
    name: string;
    description: string;
    autoLinkPatterns: AutoLinkPattern[];
    status: DefectStatusEnum;
    severity: DefectSeverityEnum;
    type: DefectTypeEnum;
    tag?: Tag;
    jiraIssueKey?: string;
    jiraIssueUrl?: string;
    testResultsCount: number;
    testCasesCount: number;
    testRunsCount: number;
    testPlansCount: number;
    createdByUser: string;
    lastUpdateByUser: number;
    createdAt: string;
    updatedAt: string;
};

export type DefectsRequestParams = {
    page_index: number;
    page_size: number;
};

export type DefectsMultipleActionParams = {
    ids: Defect['pk'][];
    status?: Defect['status'];
};

export type AutoLinkPattern = {
    pk: string;
    name: string;
    errorMessagePattern: string;
    stackTracePattern: string;
};

export type DefectFormValues = {
    name: string;
    description: string;
    jiraIssue: JiraIssue | null;
    type: DefectTypeEnum;
    autoLinkPatterns: AutoLinkPattern[];
};

export type GetDefectParams = {
    defectId: Defect['pk'];
};

export type AutoLinkPatternDialogAction = 'add' | 'edit';

export type EditDefectParams = Partial<DefectFormValues & { pk: Defect['pk']; status: Defect['status'] }>;

export type AutoLinkPatternField = keyof AutoLinkPattern;

export type JiraIssue = {
    key: string;
    jiraLink: string;
    name: string;
};

export type JiraIssuesRequestParams = {
    page_index: number;
    page_size: number;
};
